function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M59,34.66c-.63-2.54-2.8-8.39-4-11.65a5,5,0,0,0-4.67-3.21H41V19a5,5,0,0,0-5-5H8a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V16H36a3,3,0,0,1,3,3V42H22.86a7.95,7.95,0,0,0-7.72,0H9V32a1,1,0,0,0-2,0V49a1,1,0,0,0,1,1h2a1,1,0,0,0,0-2H9V44h3.76a8,8,0,1,0,12.48,0H39v4H28a1,1,0,0,0,0,2H40a1,1,0,0,0,1-1V21.8h9.25a3,3,0,0,1,2.8,1.93c1.23,3.21,3.38,9,4,11.41C57.7,37.86,58.57,45.2,58.88,48H58a1,1,0,0,0,0,2h2a1,1,0,0,0,1-1.11C61,48.46,59.84,38.17,59,34.66ZM19,55a6,6,0,1,1,6-6A6,6,0,0,1,19,55Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18,21a1,1,0,0,0,0-2H8a1,1,0,0,0,0,2Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4,21H5a1,1,0,0,0,0-2H4a1,1,0,0,0,0,2Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20,27H19a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17,28a1,1,0,0,0-1-1H6a1,1,0,0,0,0,2H16A1,1,0,0,0,17,28Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21,24a1,1,0,0,0-1-1H4a1,1,0,0,0,0,2H20A1,1,0,0,0,21,24Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54,34H46V25h5a1,1,0,0,0,0-2H45a1,1,0,0,0-1,1V35a1,1,0,0,0,1,1h9a1,1,0,0,0,0-2Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49,41a8,8,0,1,0,8,8A8,8,0,0,0,49,41Zm0,14a6,6,0,1,1,6-6A6,6,0,0,1,49,55Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49,45a4,4,0,1,0,4,4A4,4,0,0,0,49,45Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,49,51Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19,45a4,4,0,1,0,4,4A4,4,0,0,0,19,45Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,19,51Z"
}));

function SvgIcDeliveryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 80",
    x: "0px",
    y: "0px",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shopping &amp;amp; E-Commerce") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeliveryIcon);
export default __webpack_public_path__ + "static/media/ic_delivery_icon.78c0039c.svg";
export { ForwardRef as ReactComponent };